// TODO: нужно будет сделать рекурсию на случай если вложенность будет больше 2 уровня
const setAllRights = (object) => {
  for (const key in object) {
    const type = typeof object[key]

    if (type === 'object') {
      const secondLvlObject = object[key]

      for (const k in secondLvlObject) {
        const secondType = typeof secondLvlObject[k]

        if (secondType === 'object') {
          const thirdLvlObject = secondLvlObject[k]
          for (const j in thirdLvlObject) {
            thirdLvlObject[j] = true
          }
        } else {
          secondLvlObject[k] = true
        }
      }
    } else {
      object[key] = true
    }
  }
}
const removeAllRights = (object) => {
  for (const key in object) {
    const type = typeof object[key]

    if (type === 'object') {
      const secondLvlObject = object[key]

      for (const k in secondLvlObject) {
        const secondType = typeof secondLvlObject[k]

        if (secondType === 'object') {
          const thirdLvlObject = secondLvlObject[k]
          for (const j in thirdLvlObject) {
            thirdLvlObject[j] = false
          }
        } else {
          secondLvlObject[k] = false
        }
      }
    } else {
      object[key] = false
    }
  }
}

const blackListUsersRead = [
  'demo@admin.ltd'
]

const state = () => ({
  rightsList: [],
  // сотрудники
  users: {
    access: false,
    extendedInfo: false,
    password: false,
    subordinates: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // задачи
  tasks: {
    access: false,
    export: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Чат
  dialogs: {
    access: false,
    roomActionAccess: false,
    roomActions: {
      add: false,
      update: false,
      remove: false
    },
    messageActionAccess: true,
    messageActions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Новостная лента
  feed: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // мероприятия
  feedActivity: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // опросы
  feedPoll: {
    access: false
  },

  // группы
  userGroups: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // структура организации
  userDepartments: {
    access: false,
    settings: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // справочники
  directories: {
    access: false
  },

  // календарь мероприятий других сотрудников
  userActivityCalendar: {
    access: false
  },

  // ПВХ
  pvh: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Договора
  contracts: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Контрагенты
  contractors: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },
  // Листы согласования
  approve: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Логистика
  logistic: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Эдо
  edo: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Пто
  pto: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  },

  // Орг. стандарты
  standards: {
    access: false,
    actionAccess: false,
    actions: {
      add: false,
      update: false,
      remove: false
    }
  }
})

const getters = {
  getRoleRightsUsers: state => state.users,
  getRoleRightsTasks: state => state.tasks,
  getRoleRightsDialogs: state => state.dialogs,
  getRoleRightsFeed: state => state.feed,
  getRoleRightsFeedActivity: state => state.feedActivity,
  getRoleRightsFeedPoll: state => state.feedPoll,
  getRoleRightsUserGroups: state => state.userGroups,
  getRoleRightsUserDepartments: state => state.userDepartments,
  getRoleRightsDirectories: state => state.directories,
  getRoleRightsUserActivityCalendar: state => state.userActivityCalendar,
  getRoleRightContracts: state => state.contracts,
  getRoleRightContractors: state => state.contractors,
  getRoleRightPvh: state => state.pvh,
  getRoleRightLogistic: state => state.logistic,

  // роли
  isAdmin: state => state.rightsList.includes('administrator'),
  isLeader: state => state.rightsList.includes('leader'),
  isOK: state => state.rightsList.includes('ok'),

  // Доступы
  // сотрудники
  rightsUsersRead: (_, __, ___, rootGetters) => {
    return !blackListUsersRead.includes(rootGetters.currentUserEmail)
  },
  rightsUsersUpdate: (state, getters) => {
    return getters.isAdmin || getters.isLeader || getters.isOK
  },
  // Логистика
  rightsLogisticAll: (state, getters) => {
    return getters.isAdmin || state.rightsList.includes('logistics_full')
  },
  rightsLogisticRead: (state, getters) => {
    return getters.isLeader || state.rightsList.includes('logistics_read')
  },
  // ПТО + Сметный
  rightsPtoAll: (state, getters) => {
    return getters.isAdmin || state.rightsList.includes('pto_full')
  },
  rightsPtoRead: (state, getters) => {
    return getters.isLeader || state.rightsList.includes('pto_read')
  }
}

const mutations = {
  '[roles] REMOVE_RIGHTS': (state) => {
    removeAllRights(state)
    state.rightsList = []
  },
  '[roles] SET_RIGHTS': (state, roles) => {
    const roleSlugArr = roles.map(role => role.slug)

    if (roleSlugArr.indexOf('worker') + 1) {
      state.users.access = true

      state.feed.access = true

      state.userDepartments.access = true
    }

    if (roleSlugArr.indexOf('itr') + 1) {
      state.users.access = true

      state.tasks.access = true
      state.tasks.actionAccess = true
      state.tasks.actions = {
        add: true,
        update: true,
        remove: true
      }

      state.dialogs = {
        access: true,
        roomActionAccess: true,
        roomActions: {
          add: true,
          update: true,
          remove: false
        },
        messageActionAccess: true,
        messageActions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.feed = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.feedActivity = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.userGroups = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.userDepartments.access = true
    }

    if (roleSlugArr.indexOf('leader') + 1) {
      state.users.access = true
      state.users.extendedInfo = true
      state.users.subordinates = true
      state.users.actionAccess = true
      state.users.actions.update = true

      state.tasks.access = true
      state.tasks.export = true
      state.tasks.actionAccess = true
      state.tasks.actions = {
        add: true,
        update: true,
        remove: true
      }

      state.dialogs = {
        access: true,
        roomActionAccess: true,
        roomActions: {
          add: true,
          update: true,
          remove: true
        },
        messageActionAccess: true,
        messageActions: {
          add: true,
          update: true,
          remove: true
        }
      }

      state.feed = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.feedActivity = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: true
        }
      }

      state.userGroups = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.userDepartments = {
        access: true,
        settings: false,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }
    }

    if (roleSlugArr.indexOf('ok') + 1) {
      state.users = {
        access: true,
        extendedInfo: true,
        password: false,
        subordinates: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: true
        }
      }

      state.tasks.access = true
      state.tasks.actionAccess = true
      state.tasks.actions = {
        add: true,
        update: true,
        remove: false
      }

      state.dialogs = {
        access: true,
        roomActionAccess: true,
        roomActions: {
          add: true,
          update: true,
          remove: false
        },
        messageActionAccess: true,
        messageActions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.feed = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.feedActivity = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: false
        }
      }

      state.userGroups = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: true
        }
      }

      state.userDepartments = {
        access: true,
        settings: false,
        actionAccess: true,
        actions: {
          add: true,
          update: true,
          remove: true
        }
      }

      state.directories.access = true
    }

    if (roleSlugArr.indexOf('pvc_administrator') + 1) {
      state.pvh = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }

    if (roleSlugArr.indexOf('approve_full') + 1) {
      state.approve = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }
    
    if (roleSlugArr.indexOf('pvc_read') + 1) {
      state.pvh = {
        access: true,
        actionAccess: false,
        actions: {
          add: false,
          remove: false,
          update: false
        }
      }
    }

    if (roleSlugArr.indexOf('treaty_full') + 1) {
      state.contracts = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }
    if (roleSlugArr.indexOf('treaty_read') + 1) {
      state.contracts = {
        access: true,
        actionAccess: false,
        actions: {
          add: false,
          remove: false,
          update: false
        }
      }
    }

    if (roleSlugArr.indexOf('partner_full') + 1) {
      state.contractors = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }
    if (roleSlugArr.indexOf('partner_read') + 1) {
      state.contractors = {
        access: true,
        actionAccess: false,
        actions: {
          add: false,
          remove: false,
          update: false
        }
      }
    }

    if (roleSlugArr.indexOf('administrator') + 1) {
      setAllRights(state)
    }

    if (roleSlugArr.indexOf('logistics_full') + 1) {
      state.logistic = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }

    if (roleSlugArr.indexOf('logistics_read') + 1) {
      state.logistic = {
        access: true,
        actionAccess: false,
        actions: {
          add: false,
          remove: false,
          update: false
        }
      }
    }

    if (roleSlugArr.indexOf('edo_full') + 1) {
      state.edo = {
        access: true,
        actionAccess: true,
        actions: {
          add: true,
          remove: true,
          update: true
        }
      }
    }

    if (roleSlugArr.indexOf('can_delete') + 1) {
      state.dialogs = {
        access: true,
        roomActionAccess: true,
        roomActions: {
          add: true,
          update: true,
          remove: true
        },
        messageActionAccess: true,
        messageActions: {
          add: true,
          update: true,
          remove: true
        }
      }
    }

    state.rightsList = roleSlugArr
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
